import React from "react";
import styled from "styled-components";
import { Radius, form } from "@glossy";
import { Checkable, checkable } from "@ui-kit/form/checkable";

const Marker = styled.svg`
  color: ${(props) => form(props, "include")};
`;

const Box = styled.div<Pick<Checkable, "checked">>`
  ${checkable.box};
  border-radius: ${Radius.Small};
`;

const Label = styled.span<Pick<Checkable, "checked">>`
  ${checkable.label};
  color: ${({ checked, ...props }) =>
    form(
      props,
      checked === true ? "include" : checked === false ? "exclude" : "primary"
    )};
  text-decoration: ${({ checked }) => checked === false && "line-through"};
`;

const Root = styled.div<
  Pick<Checkable, "checked" | "disabled" | "inline"> & { isVisible: boolean }
>`
  ${checkable.root};
  :not(:hover) {
    ${Box} {
      opacity: ${({ checked }) => !checked && 0.5};
      visibility: ${({ checked, isVisible }) =>
        !isVisible && checked === false && "hidden"};
    }
    ${Marker} {
      visibility: ${({ checked }) => !checked && "hidden"};
    }
  }
`;

const UiKitFormCheckbox = ({
  label,
  checked,
  disabled,
  inline,
  onClick,
  isVisible,
  className,
}: Checkable) => {
  const handleClick = (e) => {
    if (!disabled && onClick) {
      // Stop propagation to avoid handle twice (<label /> and <input />)
      e.preventDefault();
      e.stopPropagation();
      onClick(e, !checked);
    }
  };

  return (
    <Root
      {...{ checked, disabled, inline, className }}
      onClick={handleClick}
      isVisible={isVisible}
      role="checkbox"
    >
      <Box checked={checked}>
        <Marker
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
          width="14"
          height="14"
        >
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="currentColor"
            strokeWidth="2"
            d="M4 7.8c.9.7 1.6 1.6 2.2 2.5C7.2 8 8.4 5.8 10 3.8"
          />
        </Marker>
      </Box>
      {!!label && <Label checked={checked}>{label}</Label>}
    </Root>
  );
};

export default UiKitFormCheckbox;
